export const PLUGIN_SETUP_SIDEBAR_HINT_STATUS_STORAGE_KEY =
    'plugin_setup_sidebar_hint_pending_v3';

export type PluginSetupSidebarHintPersistedStatus = 'pending';
export type PluginSetupSidebarHintState = 'idle' | 'requested' | 'visible';
export type PluginSetupSidebarHintEvent =
    | 'automatic-setup-closed'
    | 'trigger-ready'
    | 'dismissed';

export const resolvePluginSetupSidebarHintInitialState = (
    persistedStatus: PluginSetupSidebarHintPersistedStatus | null,
): PluginSetupSidebarHintState => (
    persistedStatus === 'pending' ? 'requested' : 'idle'
);

export const transitionPluginSetupSidebarHint = (
    state: PluginSetupSidebarHintState,
    event: PluginSetupSidebarHintEvent,
): PluginSetupSidebarHintState => {
    if (event === 'automatic-setup-closed') {
        return 'requested';
    }

    if (event === 'trigger-ready') {
        return state === 'requested' ? 'visible' : state;
    }

    return 'idle';
};

export const isPluginSetupSidebarHintVisible = (
    state: PluginSetupSidebarHintState,
) => state === 'visible';
